export default __webpack_public_path__ + "static/media/B0005.0138e352.png";